import React, { useEffect, useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import DesktopMenu from '../../common/DesktopMenu/index';
import MobileMenu from '../../common/MobileMenu/index';
import useWindowSize from '../../common/windowSize';
import NewFooter from '../../common/NewFooter';
import {
    LoginInputBusiness,
    LoginLabelBusiness,
    LoginLabel,
    ButtonWrapper,
} from './styles';
import {
    Background,
    LoginBackground,
    LoginBackgroundImage,
    LoginTitle,
    LoginInput,
    LoginButton,
} from '../Login/styles';
import loginBackground from '../../assets/login/blue-part-login.svg';
import { publicAPI } from '../../utils/api';
import { toast } from "react-toastify";
import Button from '../../common/SmallButton';
import ToggleButton from '../../common/ToggleButton';
import { postalCodes } from '../../common/postalCodes';
import RegistrationTerms from '../../assets/AGB-Bacchus-Drinks-GmbH-Käufer.pdf';
import { useTranslation } from "react-i18next";
import './style.css';

const Registration = () => {
    const size = useWindowSize()
    const navigate = useNavigate()
    const [mobileMenu, setMobileMenu] = useState(false)
    const [registrationUser, setRegistrationUser] = useState({});
    const [loading, setLoading] = useState(false);
    const [number, setNumber] = useState(1);
    const [isBusiness, setIsBusiness] = useState(true);
    const [termsAndCond, setTermsAndCond] = useState(false);
    const { t } = useTranslation();

    const registration = async (e) => {
        e.preventDefault()
        setLoading(true)
        if(!termsAndCond) return [toast.info('Must read and accept terms and conditions.'), setLoading(false)]

        delete registrationUser['repeatedPassword'];
        const userDTO = registrationUser;
        try{
            userDTO.terms = termsAndCond;
            userDTO.userType = isBusiness ? 'BUSINESS' : 'PRIVATE';
            await publicAPI.post(`/public/bacchus/registration`, userDTO);
            navigate("/successful-registration")
        } catch (error){
            setLoading(false);
            if(error.request.status === 409) return toast.error(`User is already exist`)
            if(error.request.status === 500) return toast.error('Internal server error')
        }
    }

    const setUserData = (value, label) => {
        if(label === 'postCode'){ 
            setRegistrationUser({...registrationUser,
                [label]: value,
                place: postalCodes[value]
            });
        }else{
            setRegistrationUser({...registrationUser,
                [label]: value
            });
        }
    }

    const setNumberFoo = (value) => {
        if(number === 2 && value === 'prev'){
            setNumber(1)
        } else if(number === 3 && value === 'prev'){
            setNumber(2)
        }

        if(number === 1 && value === 'next'){
            if(isBusiness && !registrationUser.company) return toast.info('Company name is empty or change type of profile');
            if(!registrationUser.name) return toast.error('Name is empty');
            if(!registrationUser.surname) return toast.error('Last name is empty');
            if(!registrationUser.password) return toast.error('Password is empty');
            if(registrationUser.password !== registrationUser.repeatedPassword) return toast.error('Password must be the same');
            setNumber(2)
        } else if(number === 2 && value === 'next'){
            if(!registrationUser.username) return toast.error('E-mail is empty');
            if(!registrationUser.phone) return toast.error('Phone is empty');
            if(!registrationUser.postCode) return toast.error('Post code is empty');
            if(!registrationUser.place) return toast.error('Place is empty');
            if(!registrationUser.address) return toast.error('Address is empty');
            setNumber(3)
        } 
    }

    useEffect(() => {
      if (size.width < 1200) {
        setMobileMenu(true);
      } else {
        setMobileMenu(false);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [size]);

    return(
        <>
            {mobileMenu ? <MobileMenu single={true}/> : <DesktopMenu single={true}/> }
            <Background>
                <LoginBackground>
                    <LoginBackgroundImage src={loginBackground}/>
                    <LoginTitle>{t("accountRegistration")}</LoginTitle>
                    {number === 1 ?
                        <>
                            <ToggleButton 
                                isBusiness={isBusiness} 
                                function={() => setIsBusiness(!isBusiness)}
                                />
                            <LoginLabelBusiness isBusiness={isBusiness}>{t("companyName")} </LoginLabelBusiness>
                            <LoginInputBusiness 
                                type="text" 
                                placeholder={t("enterCompanyName")}
                                disabled={loading}
                                isBusiness={isBusiness}
                                onChange={(e) => setUserData(e.target.value, 'company')}
                                value={registrationUser?.company || ''}
                                />
                            <LoginLabel>{t("name")}: </LoginLabel>
                            <LoginInput 
                                type="text" 
                                placeholder={t("enterName")}
                                disabled={loading}
                                onChange={(e) => setUserData(e.target.value, 'name')}
                                value={registrationUser?.name || ''}
                                isBusiness
                                />
                            <LoginLabel>{t("lastName")} </LoginLabel>
                            <LoginInput 
                                type="text" 
                                placeholder={t("enterLastName")}
                                disabled={loading}
                                onChange={(e) => setUserData(e.target.value, 'surname')}
                                value={registrationUser?.surname || ''}
                                isBusiness
                                />
                            <LoginLabel>{t("password")} </LoginLabel>
                            <LoginInput 
                                type="password" 
                                placeholder={t("enterPassword")} 
                                disabled={loading}
                                onChange={(e) => setUserData(e.target.value, 'password')}
                                value={registrationUser?.password || ''}
                                isBusiness
                                />
                            <LoginLabel>{t("repeatPassword")} </LoginLabel>
                            <LoginInput 
                                type="password" 
                                placeholder={t("passwordSame")}
                                disabled={loading}
                                onChange={(e) => setUserData(e.target.value, 'repeatedPassword')}
                                value={registrationUser?.repeatedPassword || ''}
                                isBusiness
                                />
                        </>
                        : number === 2 ?
                        <>
                            <LoginLabel>{t("email")}: </LoginLabel>
                            <LoginInput 
                                type="text" 
                                placeholder={t("enterEmail")} 
                                disabled={loading}
                                onChange={(e) => setUserData(e.target.value, 'username')}
                                value={registrationUser?.username || ''}
                                isBusiness
                                />
                            <LoginLabel>{t("phone")}: </LoginLabel>
                            <LoginInput
                                type="text"
                                placeholder={t("enterPhone")}
                                disabled={loading}
                                onChange={(e) => setUserData(e.target.value, 'phone')}
                                value={registrationUser?.phone || ''}
                                isBusiness
                                />
                            <LoginLabel>{t("postalCode")} </LoginLabel>
                            <LoginInput
                                type="text"
                                placeholder={t("enterPostalCode")}
                                disabled={loading}
                                onChange={(e) => setUserData(e.target.value, 'postCode')}
                                value={registrationUser?.postCode || ''}
                                isBusiness
                                />
                            <LoginLabel>{t("city")} </LoginLabel>
                            <LoginInput
                                type="text"
                                placeholder={t("enterCity")}
                                disabled={loading}
                                onChange={(e) => setUserData(e.target.value, 'place')}
                                value={postalCodes[registrationUser?.postCode] || registrationUser?.place || ''}
                                isBusiness
                                />
                            <LoginLabel>{t("address")} </LoginLabel>
                            <LoginInput
                                type="text"
                                placeholder={t("enterAddress")}
                                disabled={loading}
                                onChange={(e) => setUserData(e.target.value, 'address')}
                                value={registrationUser?.address || ''}
                                isBusiness
                                />
                        </>
                        : 
                        <>
                            {isBusiness ? <LoginLabel>{t("companyName")} {registrationUser.company}</LoginLabel> : null}
                            <LoginLabel><strong>{t("name")}: </strong><em>{registrationUser.name} {registrationUser.surname}</em></LoginLabel>
                            <LoginLabel><strong>{t("city")} </strong><em>{registrationUser.postCode}, {registrationUser.place}</em></LoginLabel>
                            <LoginLabel><strong>{t("address")} </strong><em>{registrationUser.address}</em></LoginLabel>
                            <LoginLabel><strong>{t("contactEmail")} </strong><em>{registrationUser.username}</em></LoginLabel>
                            <LoginLabel><strong>{t("contactPhone")} </strong><em>{registrationUser.phone}</em></LoginLabel>
                            <ButtonWrapper centered>
                                {/* <input 
                                    type="checkbox" 
                                    style={{marginRight: '15px'}} 
                                    onChange={() => setTermsAndCond(!termsAndCond)} 
                                    checked={termsAndCond}
                                    disabled={loading}
                                    /> */}
                                <div 
                                    className="checkbox"
                                    style={{marginRight: '15px'}} >
                                    <input 
                                        id="input-1" 
                                        type="checkbox"
                                        onChange={() => setTermsAndCond(!termsAndCond)} 
                                        checked={termsAndCond}
                                        disabled={loading}/>
                                    <label for="input-1"></label>
                                </div>
                                <p style={{color: 'white'}}>
                                {t("iAgree")} <a href={RegistrationTerms} style={{color: 'white'}}>{t("termsConditions")}</a>
                                </p>
                            </ButtonWrapper>
                            <LoginButton 
                                type="submit" 
                                value="Submit"
                                disabled={loading}
                                onClick={(e) => registration(e)}
                                >
                                    {loading ? `${t("loading")}...` : t("register")}
                            </LoginButton>
                            <Backdrop
                                sx={{ color: '#fff', zIndex: 1000 }}
                                open={loading}
                                >
                                <CircularProgress color="inherit" />
                            </Backdrop>
                        </>
                    }
                    <ButtonWrapper>
                        <Button 
                            name={t("prev")}
                            function={() => setNumberFoo('prev')}
                            isDisabled={loading}/>
                        {number !== 3 ? <Button name={t("next")} function={() => setNumberFoo('next')}/> : null}
                    </ButtonWrapper>
                </LoginBackground>
            </Background>
            <NewFooter/>
        </>
    )
}
export default Registration;
